import { BreadcrumpComponent } from '../components/subcomponents/BreadcrumpCompont';
import { ExploreCenters } from '../components/Centers.component';
import heroImage from '../assets/images/hero-image.png';

export const Centers: React.FC = () => {
    return (
        <>
            <BreadcrumpComponent
                imageCover={heroImage}
                subtitle="De l'innovation technologique à la gestion économique, découvrez nos pôles d'expertise. Trouvez la filière idéale pour transformer votre passion en une carrière solide et impactante."
                title="Nos centres de recherche"
            />
            <div className="page-content">
                <ExploreCenters showHeader={false} />
            </div>
        </>
    );
}
